import { render, staticRenderFns } from "./ModalCompartilharOrcamento.vue?vue&type=template&id=0a1bb126&scoped=true&"
import script from "./ModalCompartilharOrcamento.vue?vue&type=script&lang=js&"
export * from "./ModalCompartilharOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompartilharOrcamento.vue?vue&type=style&index=0&id=0a1bb126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1bb126",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
